import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, Redirect } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, Form, Dropdown, InputGroup } from "react-bootstrap";
import "./login.css";
import background from "../../../bg-login.png";
import logo from "../../../logo-roundQM.svg";
import axios from "axios";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useFormik } from "formik";
import * as Yup from "yup";
import Alert from "../../../components/Alert/Alert";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import { checkResetToken } from "../../../redux/actions/user";
const ResetPassword = (props) => {
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [display, setDisplay] = useState("none");
  const [type, setType] = useState("password");
  const [typeConfirmPassword, setTypeConfirmPassword] = useState("password");
  const { message, status } = useSelector((state) => state.message);
  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState("");
  const dispatch = useDispatch();
  const [redirectionLoginpage, setRedirection] = useState(false);

  //Formik
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(12, "Le mot de passe doit contenir au moins 12 caractères")
        .max(14, "Le mot de passe doit contenir au maximum 14 caractères")
        .required("Le mot de passe est obligatoire")
        .matches(
          /^(?=.*[A-Z]).*$/,
          "Le mot de passe doit contenir au moins un caractère majuscule"
        )
        .matches(/\d/, "Le mot de passe doit contenir au moins un chiffre")
        .matches(
          /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/,
          "Le mot de passe doit contenir au moins un caractère spécial"
        ),

      confirmPassword: Yup.string().when("password", (password, field) => {
        if (password) {
          return field
            .required("La confirmation de mot de passe est obligatoire")
            .oneOf(
              [Yup.ref("password")],
              "Les mots de passe ne correspondent pas"
            );
        }
      }),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await resetPassword(params.get("token"));
      setLoading(false);
    },
  });

  useEffect(() => {
    dispatch(checkResetToken(params.get("token")));
  }, [dispatch]);

  useEffect(() => {
    if (status === 404) {
      setRedirection(true);
    }
  }, [status]);

  const onDisplay = (display) => {
    setDisplay(display);
  };

  const langOptions = [
    { name: "Français" },
    { name: "Anglais" },
    { name: "Arabe" },
  ];

  const change = (eventkey) => {
    setLang(eventkey);
    i18n.changeLanguage(eventkey);
  };

  const resetPassword = (token) => {
    axios
      .put(`${process.env.REACT_APP_ADMIN_API_URL}/api/users/reset-password`, {
        token,
        password: formik.values.password,
      })
      .then((res) => {
        history.push("/login");
      });
  };

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setType((prevType) => (prevType === "password" ? "text" : "password"));
    } else if (field === "confirmPassword") {
      setTypeConfirmPassword((prevType) =>
        prevType === "password" ? "text" : "password"
      );
    }
  };

  return (
    <>
      {redirectionLoginpage ? (
        <Redirect to={{ pathname: "/404" }} />
      ) : (
        <div>
          <div className="login-logo">
            <p className="login-logo-title">
              Round <p className="login-logo_subtitle">QUALITY MONITORING</p>
            </p>
            <img
              style={{ maxWidth: "25%", paddingBottom: 40 }}
              src={logo}
              alt="Logo"
            />
          </div>
          <div className="split left">
            <div className="centered">
              <div>
                <p
                  className="login-welcome-text"
                  style={{ color: "#B7B7B7", fontFamily: "Gilroy" }}
                >
                  {t("common.welcome")}
                  <span className="login-roundesk-title">Roundesk !</span>
                </p>
              </div>

              <Form onSubmit={formik.handleSubmit}>
                <Form.Group className="d-flex flex-column">
                  <InputGroup className="input-group-login mb-3">
                    <Form.Control
                      type={type}
                      className="form-control input-sm"
                      maxLength="64"
                      placeholder="Nouveau mot de passe"
                      id="password"
                      name="password"
                      autoComplete={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                    />
                    <IconButton
                      className="password-visibility-icon"
                      onClick={() => togglePasswordVisibility("password")}
                    >
                      {type === "password" ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputGroup>
                  {formik.touched.password && formik.errors.password ? (
                    <div className="text-danger">{formik.errors.password}</div>
                  ) : null}

                  <InputGroup className="input-group-login">
                    <Form.Control
                      type={typeConfirmPassword}
                      className="form-control input-sm"
                      maxLength="64"
                      placeholder="Confirmer le mot de passe *"
                      id="confirmPassword"
                      name="confirmPassword"
                      autoComplete={formik.values.confirmPassword}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.confirmPassword}
                    />
                    <IconButton
                      className="password-visibility-icon"
                      onClick={() =>
                        togglePasswordVisibility("confirmPassword")
                      }
                    >
                      {typeConfirmPassword === "password" ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputGroup>
                  {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword ? (
                    <div className="text-danger">
                      {formik.errors.confirmPassword}
                    </div>
                  ) : null}
                </Form.Group>
                <Button
                  className="btn-secondary btn-login mt-3"
                  variant="primary"
                  type="submit"
                >
                  {t("common.connect-button")}
                  {loading && (
                    <>
                      &nbsp;
                      <span className="spinner-border spinner-border-sm"></span>
                    </>
                  )}
                </Button>
              </Form>
              {message && (
                <Alert
                  message={message}
                  status={"danger"}
                  marginTop={"8rem"}
                  display={display}
                  onDisplay={onDisplay}
                />
              )}
            </div>
            <div className="footer-login-page ">
              <div>
                <span>Roundesk 2024 </span>-{" "}
                <span>Tous droits réservés - Tél : 01 76 234 234</span>
              </div>
            </div>
          </div>

          <div
            className="split right"
            style={{ backgroundImage: `url(${background})` }}
          >
            <Dropdown onSelect={change}>
              <Dropdown.Toggle className="select-btn" id="dropdown-basic">
                <span>
                  {lang === "fr"
                    ? "Français"
                    : lang === "en"
                    ? "Anglais"
                    : "Français"}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="fr" href="#/action-1">
                  <span className="spacing">Français</span>
                  <label className="container container-checkbox">
                    <input
                      value="fr"
                      type="radio"
                      checked={lang === "fr"}
                      name="langue"
                    />
                    <span className="checkmark"></span>
                  </label>
                </Dropdown.Item>
                <Dropdown.Item eventKey="en" href="#/action-2">
                  <span className="spacing">Anglais&nbsp;</span>{" "}
                  <label className="container container-checkbox">
                    <input
                      value="en"
                      type="radio"
                      name="langue"
                      checked={lang === "en"}
                    />
                    <span className="checkmark"></span>
                  </label>{" "}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <h1 className="slogan">{t("common.login-quote")}</h1>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPassword;
